import { Box, debounce, Grid, Stack, TextField, Typography } from "@mui/material";
import { InputProduto } from "..";
import { useContext, useEffect } from "react";
import { AuthContext } from "../../../../../contexts/AuthContext";
import { useFormContext } from "react-hook-form";
import { gerarMensagem } from "./gerarMensagem";
import DisplayIncluirNaoSugeridos from "./DisplayIncluirNaoSugeridos";

export default function Step02({
    show = false,
}: Step02Props) {

    const { getUserData } = useContext(AuthContext);
    const user = getUserData()

    const { setValue, watch } = useFormContext()
    const selecionados: Array<InputProduto> = [...watch('nao_sugeridos'), ...watch('items')];

    const mensagem = gerarMensagem(selecionados, watch('observacao'), user);

    const handleChangeObservacoes = debounce((value: string) => {
        const formattedText = value.replace(/(.{80})/g, "$1\n");
        setValue('observacao', formattedText);
    }, 300);

    useEffect(() => {
        setValue('descricao', mensagem)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mensagem])

    return (
        <Box p={1} mt={4} display={show ? 'block' : 'none'}>
            <Box p={2} sx={{ backgroundColor: "#EEE", borderRadius: 2 }}>
                {selecionados.length > 0 ? (
                    <pre dangerouslySetInnerHTML={{ __html: mensagem }} />
                ) : (
                    <Typography color="text.secondary" textAlign="center" py={4}>
                        Nenhum item foi adicionado à solicitação
                    </Typography>
                )}
            </Box>

            <Grid container mt={3} spacing={2}>
                <Grid size={{ xs: 12, md: 6 }}>
                    <DisplayIncluirNaoSugeridos />
                </Grid>

                <Grid size={{ xs: 12, md: 6 }}>
                    <TextField
                        rows={4}
                        multiline
                        fullWidth
                        variant="outlined"
                        slotProps={{ inputLabel: { shrink: true } }}
                        label="Adicionar observações (opcional)"
                        onChange={(e) => handleChangeObservacoes(e.target.value)}
                        placeholder="Digite aqui alguma informação adicional para incluir na mensagem"
                    />
                    <Stack mt={3} direction="column" alignItems="flex-end" justifyContent="center">
                        <Typography>A mensagem acima será enviada para o responsável,</Typography>
                        <Typography>Deseja continuar?</Typography>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}


interface Step02Props {
    show: boolean;
}

export interface FormDataObservacao {
    observacao?: string;
}
/* 
return (
    
) */